// eslint-disable-next-line @typescript-eslint/no-explicit-any
const hasValue = (value: any): boolean => typeof value !== 'undefined' && value !== null;

export default hasValue;
